var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '@hellodarwin/core/lib/components/common/div';
import { useAppData } from '@hellodarwin/core/lib/features/providers/app-data-provider';
import { useBreadcrumbs } from '@hellodarwin/core/lib/features/providers/breadcrumbs-provider';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { usePremiumAccess } from '../../providers/premium-access-provider';
import PremiumFeatureOverlay from '../premium-access/components/premium-paywall-overlay';
import PageContainer from './components/PageContainer';
import PageHeading from './components/PageHeading';
const PageLayoutV2 = (_a) => {
    var { children, className, tabTitle, isLoading, styles, noPadding, defaultNavCollapsed, title, subtitle, actions, footnote, status, handleBack, noFooter, goBackTo, hideBackgroundIcons } = _a, appHeaderProps = __rest(_a, ["children", "className", "tabTitle", "isLoading", "styles", "noPadding", "defaultNavCollapsed", "title", "subtitle", "actions", "footnote", "status", "handleBack", "noFooter", "goBackTo", "hideBackgroundIcons"]);
    const { withoutPaddingRight, withoutPaddingHorizontal, withoutPaddingLeft, breadcrumbs, } = appHeaderProps;
    const { isPageAccessible } = usePremiumAccess();
    const { pathname } = useLocation();
    const isAccessible = isPageAccessible(pathname);
    const { setBreadCrumbs } = useBreadcrumbs();
    const { setNavCollapsed } = useAppData();
    const shouldRenderHeading = !!(title || actions);
    useEffect(() => {
        setBreadCrumbs(breadcrumbs);
    }, [breadcrumbs]);
    useEffect(() => {
        if (!!defaultNavCollapsed) {
            setNavCollapsed(true);
        }
    }, [defaultNavCollapsed]);
    const { app } = usePlatform();
    const { t } = useTranslations();
    const theme = useTheme();
    useEffect(() => {
        if (typeof document !== 'undefined') {
            if (!!tabTitle) {
                document.title = `${tabTitle} | ${t(`appsNames|${app}`)}`;
            }
            else if ((typeof title === 'string' || title instanceof String) &&
                !!title) {
                document.title = `${title} | ${t(`appsNames|${app}`)}`;
            }
            else {
                document.title = t(`appsNames|${app}`);
            }
        }
    }, [tabTitle]);
    if (isLoading)
        return _jsx(_Fragment, {});
    const containerProps = Object.assign({ className, cap: app === 'admin' ? theme.caps.xl : theme.caps.normal, withoutPaddingRight,
        withoutPaddingHorizontal,
        styles,
        noPadding, overflowHidden: !isAccessible, app }, (hideBackgroundIcons && {
        backgroundColor: theme.colors.beige_3,
    }));
    const headingProps = {
        title,
        subtitle,
        actions,
        footnote,
        status,
        handleBack,
        withoutPaddingHorizontal: withoutPaddingHorizontal !== null && withoutPaddingHorizontal !== void 0 ? withoutPaddingHorizontal : noPadding,
        withoutPaddingLeft: withoutPaddingLeft !== null && withoutPaddingLeft !== void 0 ? withoutPaddingLeft : noPadding,
        withoutPaddingRight: withoutPaddingRight !== null && withoutPaddingRight !== void 0 ? withoutPaddingRight : noPadding,
        goBackTo,
        styles: styles === null || styles === void 0 ? void 0 : styles.heading,
    };
    return (_jsx(PremiumFeatureOverlay, { children: _jsxs(PageContainer, Object.assign({}, containerProps, { icons: hideBackgroundIcons
                ? undefined
                : [
                    {
                        side: 'right',
                        icon: 'Group1Filled',
                        color: theme.colors.beige_1,
                        top: 300,
                        margin: -300,
                        width: 900,
                        height: 800,
                    },
                ], noFooter: noFooter, children: [shouldRenderHeading && _jsx(PageHeading, Object.assign({}, headingProps)), _jsx(Div, { flex: "column", style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.body), { flex: 1 }), gap: 32, children: children })] })) }));
};
export default PageLayoutV2;
